export default __webpack_public_path__ + "static/media/MacDo.2dffa142.jpeg";